import { getResolvedTenantCode } from 'config/resolvedTenant';

export const scopeStorageKey = (baseKey: string, tenantCode?: string | null): string => {
  const code = tenantCode ?? getResolvedTenantCode();
  return code ? `${baseKey}__${code}` : baseKey;
};

export const tenantStorage = {
  getItem: (baseKey: string, tenantCode?: string | null): string | null =>
    localStorage.getItem(scopeStorageKey(baseKey, tenantCode)),
  setItem: (baseKey: string, value: string, tenantCode?: string | null): void =>
    localStorage.setItem(scopeStorageKey(baseKey, tenantCode), value),
  removeItem: (baseKey: string, tenantCode?: string | null): void =>
    localStorage.removeItem(scopeStorageKey(baseKey, tenantCode)),
};
